import { ComponentFactoryResolver, Injectable, Injector } from "@angular/core";

import { DynamicComponentRef } from "../classes/index";
import { SpsOptionListComponent } from "../components/index";

@Injectable()
export class SpsOptionListFactory {
    private componentFactory;

    constructor(
        componentFactoryResolver: ComponentFactoryResolver,
        private injector: Injector,
    ) {
        this.componentFactory = componentFactoryResolver.resolveComponentFactory(SpsOptionListComponent);
    }

    create<T>(): DynamicComponentRef<SpsOptionListComponent<T>> {
        const host = document.createElement("sps-option-list");
        document.body.appendChild(host);
        const componentRef = this.componentFactory.create(this.injector, [], host);
        return new DynamicComponentRef(componentRef);
    }
}
